var exports = {
  "G": "Filter_0___Y55OJ",
};

module.exports = exports;
